export const lblRegisterUser = {
    fullName:"Full Name",
    age:"Age",
    gender:"Gender",
    email:"Email Address",
    city:"City",
    education:"Education",
    occupyType:"Choose Professional or Self-Employed"
}